import { Link, useNavigate } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { Boton, EsqueletoTabla, Pill, PuntoNaranja, Tabla, TablaCabecera, TablaCelda, TablaCuerpo, TablaEncabezado, TablaFila, TituloPagina, Vacio } from "@iavmx/ui";
import { leer } from "../api";
import { duracion, mxn, relativo } from "../formato";
import { useSesion } from "../sesion";
import { ETIQUETA_ESTADO_PROPUESTA, type PropuestaLista } from "../tipos";

export const TONO_PROPUESTA: Record<string, "neutro" | "azul" | "verde" | "ambar" | "rojo"> = { borrador: "neutro", enviada: "azul", vista: "azul", aceptada: "verde", cambios_pedidos: "ambar", vencida: "neutro" };

export function Propuestas() {
  const { api, listo } = useSesion();
  const navegar = useNavigate();
  const lista = useQuery({ queryKey: ["propuestas"], queryFn: () => api.api.propuestas.$get().then((r) => leer<{ propuestas: PropuestaLista[] }>(r)), enabled: listo, refetchInterval: 60_000 });
  return (
    <>
      <TituloPagina
        descripcion="Propuesta viva: una liga por cliente, versiones en la misma liga y rastreo de lectura. Ves las tuyas; la gerencia ve todas."
        accion={
          <Boton variante="acento" tamano="sm" asChild>
            <Link to="/cotizaciones">Crear desde una cotización</Link>
          </Boton>
        }
      >
        Propuestas
        <PuntoNaranja />
      </TituloPagina>
      {lista.isLoading && <EsqueletoTabla />}
      {lista.error && <Vacio titulo="No se pudieron cargar las propuestas" texto={lista.error.message} />}
      {lista.data && lista.data.propuestas.length === 0 && <Vacio titulo="Sin propuestas todavía" texto="Una propuesta nace de una cotización con «Convertir en propuesta»." />}
      {lista.data && lista.data.propuestas.length > 0 && (
        <Tabla>
          <TablaCabecera>
            <TablaFila>
              <TablaEncabezado>Propuesta</TablaEncabezado>
              <TablaEncabezado>Estado</TablaEncabezado>
              <TablaEncabezado>Ejecutivo</TablaEncabezado>
              <TablaEncabezado className="text-right">Total</TablaEncabezado>
              <TablaEncabezado className="text-right">Aperturas</TablaEncabezado>
              <TablaEncabezado className="text-right">Lectura</TablaEncabezado>
              <TablaEncabezado>Enviada</TablaEncabezado>
            </TablaFila>
          </TablaCabecera>
          <TablaCuerpo>
            {lista.data.propuestas.map((p) => (
              <TablaFila key={p.id} className="cursor-pointer" onClick={() => void navegar({ to: "/propuestas/$id", params: { id: p.id } })}>
                <TablaCelda>
                  <Link to="/propuestas/$id" params={{ id: p.id }} className="font-semibold hover:underline">
                    {p.titulo}
                  </Link>
                  <div className="font-ui text-xs text-tinta-tenue">{p.cuenta}</div>
                </TablaCelda>
                <TablaCelda>
                  <Pill tono={TONO_PROPUESTA[p.estado] ?? "neutro"}>{ETIQUETA_ESTADO_PROPUESTA[p.estado]}</Pill>
                </TablaCelda>
                <TablaCelda>{p.ejecutivo ?? "—"}</TablaCelda>
                <TablaCelda className="text-right tabular-nums">{p.total ? mxn(p.total) : "—"}</TablaCelda>
                <TablaCelda className="text-right tabular-nums">{p.aperturas ?? 0}</TablaCelda>
                <TablaCelda className="text-right tabular-nums">{p.segundos ? duracion(p.segundos) : "—"}</TablaCelda>
                <TablaCelda className="text-tinta-tenue">{p.enviadaEn ? relativo(p.enviadaEn) : "sin enviar"}</TablaCelda>
              </TablaFila>
            ))}
          </TablaCuerpo>
        </Tabla>
      )}
    </>
  );
}
